/* Contributors Data */
const ContributersData = [
    {
        id: 0,
        name:'Aryan Garg',
        roll:'19124018',
        desc: 'FrontEnd + Backend Dev',
        img: 'https://i.ibb.co/2SSXzRQ/aryan.png',
        linkedIn:"https://www.linkedin.com/in/aryan-garg-661552198/",
        github:"https://github.com/code08-ind"
    },
    {
        id: 1,
        name:'Rohit Raj',
        roll:'19124049',
        desc: 'FrontEnd Dev',
        img: 'https://i.ibb.co/jy3yPnh/rohit.png',
        linkedIn:"https://www.linkedin.com/in/rohit-raj-337ba4215/",
        github:"https://github.com/rohit2-tech"
    },
    {
        id: 2,
        name:'Akshit Duggal',
        roll:'19124007',
        desc: 'Data Collection + Analysis',
        img: 'https://i.ibb.co/LSYqKKy/akshit.png',
        linkedIn:"https://www.linkedin.com/in/akshit-duggal-2387291a1/",
        github:"https://github.com/AkshitDuggal"
    },
    {
        id: 3,
        name:'Hashwanth Sutharapu',
        roll:'19124025',
        desc: 'Data Collection + Analysis',
        img: 'https://i.ibb.co/pP9r6CT/hashwanth.png',
        linkedIn:"https://www.linkedin.com/in/sutharapuhashwanth",
        github:"https://github.com/hashwnath"
    },
];

export default ContributersData;